<template>
    <section>


        <!-- <b-modal :active.sync="createAttribute">
            <form @submit.prevent="submitForm">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Create</p>
                    </header>
                    <section class="modal-card-body">
                        <b-field label="Code">
                            <b-input type="text" v-model="form.code" required>
                            </b-input>
                        </b-field>
                        <b-field label="Name">
                            <b-input type="text" v-model="form.name" required>
                            </b-input>
                        </b-field>
                        <b-field label="Value">
                            <b-input type="text" v-model="form.value">
                            </b-input>
                        </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button is-primary">Save</button>
                    </footer>
                </div>
            </form>
        </b-modal> -->
        <b-modal :active.sync="openModalAttach">
            <form @submit.prevent="submitFormAttach">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Associated Attributes</p>
                    </header>
                    <section class="modal-card-body">
                        <template v-if="selectedAttribute">
                            <table class="table" style="width:100%;">
                                <tr>
                                    <td>Name</td>
                                    <td>Code</td>
                                    <td class="is-narrow">Action</td>
                                </tr>
                                <tr v-for="(associated, key) in selectedAttribute.attributes.filter(element => element.archived_at == null)">
                                    <td>{{ associated.name }}</td>
                                    <td>{{ associated.code }}</td>
                                    <td>
                                        <b-button size="is-small" @click="archiveAssociatedAttribute(associated)">Unassign</b-button>
                                    </td>
                                </tr>
                            </table>
                        </template>
                        <hr>
                       <b-field label="Select Attribute">
                        <b-select expanded required v-model="attachId">
                            <option v-for="option in codeChains" :value="option.id" :key="option.id">
                                {{ option.name }}
                            </option>
                        </b-select>
                    </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" @click="openModalAttach=false">Close</button>
                        <button class="button is-primary">Assign</button>
                    </footer>
                </div>
            </form>
        </b-modal>
        <b-modal :active.sync="openCodesModal">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Associated Codes</p>
                </header>
                <section class="modal-card-body">
                    <template v-if="selectedAttribute">
                        <table class="table" style="width:100%;">
                            <tr>
                                <td>Code</td>
                                <td>Name</td>
                                <td>Group</td>
                            </tr>
                            <tr v-for="(code, key) in selectedAttribute.codes">
                                <td>{{ code.code }}</td>
                                <td>{{ code.name }}</td>
                                <td>{{ code.group }}</td>
                            </tr>
                        </table>
                    </template>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="openCodesModal=false">Close</button>
                </footer>
            </div>
        </b-modal>

        <!-- <b-button class="button is-warning" @click="achiveRestore('archive')">
            Archive
        </b-button>
        <b-button class="button is-dark" @click="achiveRestore('restore')">
            Restore
        </b-button>
        <b-button @click="unassigned = !unassigned">
            {{ unassigned ? 'Hide' : 'Show'}} Unassigned ({{ unassignedLength }})         
        </b-button> -->


        <!-- <b-checkbox v-model="include_archived">Include Archived</b-checkbox> -->


        <!-- <b-button style="float:right;" type="is-info" @click="createAttribute = true">
            Create            
        </b-button> -->

        <b-table :data="systemAttributes" :loading="isLoading" v-if="false">
            <template slot-scope="props">
                <!-- <b-table-column>
                    <div class="field">
                        <b-checkbox v-model="system_selected" :native-value="props.row.id"></b-checkbox>
                    </div>
                </b-table-column> -->
                <b-table-column field="name" label="Name">
                    <b-tooltip :label="props.row.code" position="is-right">
                        <p>{{ props.row.name }}</p>
                    </b-tooltip>
                </b-table-column>
                <b-table-column field="value" label="Value">
                    <template-component :field="findField(props.row.code)" 
                        :data="props" :isEditing.sync="isEditing" 
                        @hideSaveButton="hideSaveButton"
                        :ref="'model_' + props.row.id">
                    </template-component>
                </b-table-column>
                <b-table-column field="id" label="" width="150" >
                    <b-button
                        size="is-small"
                        @click="update(props.row)"
                        v-if="isEditing == props.row.id"
                        >SAVE</b-button>
                </b-table-column>
                <!-- <b-table-column label="Actions">
                    <template v-if="isArchived(props.row)">
                        <button class="button is-small is-dark" @click="toggleArchive(props.row, $event)">RESTORE</button>
                    </template>
                    <template v-else>
                        <button class="button is-small is-warning" @click="toggleArchive(props.row, $event)">ARCHIVE</button>
                    </template>
                </b-table-column> -->
            </template>
        </b-table>

            <!-- :data="allAttributes" -->
         <!-- <b-table :data="basicAttributes" :loading="isLoading"> -->
         <b-table :data="modelAttributes" :loading="isLoading">

            <template slot-scope="props">
                <!-- <b-table-column>
                    <attribute-checkbox :row="props.row" />
                </b-table-column> -->
                <b-table-column field="code" label="Code" >
                    {{ props.row.code }}
                </b-table-column>

                <b-table-column field="name" label="Name">
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column field="value" label="Value">
                    <!-- <b-input :value="props.row.value" @focus="isEditing = props.row.id" @blur="hideSaveButton" :ref="'model_' + props.row.id"></b-input> -->
                    <template-component :field="findField(props.row.code)" 
                        :data="props" :isEditing.sync="isEditing" 
                        @hideSaveButton="hideSaveButton"
                        :ref="'model_' + props.row.id">
                    </template-component>
                </b-table-column>

                <b-table-column field="id" label="" width="150" >
                    <b-button
                        size="is-small"
                        @click="update(props.row)"
                        v-if="isEditing == props.row.id"
                        >SAVE</b-button>
                </b-table-column>
                
                <!-- <b-table-column field="id" label="Associated" >
                    <b-button size="is-small" @click="modalAttach(props.row)">ATTRIBUTES</b-button>
                    <b-button size="is-small" @click="codelsModal(props.row)">CODES</b-button>
                </b-table-column> -->

                <!-- <b-table-column label="Actions">
                    <template v-if="isArchived(props.row)">
                        <button class="button is-small is-dark" @click="toggleArchive(props.row, $event)">RESTORE</button>
                    </template>
                    <template v-else>
                        <button class="button is-small is-warning" @click="toggleArchive(props.row, $event)">ARCHIVE</button>
                    </template>
                </b-table-column> -->
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>No Attributes.</p>
                    </div>
                </section>
            </template>
        </b-table>
    </section>
</template>
<script>
import { AttributeService } from "@/services/attributes.service";
import { BaseService } from "@/services/base.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import AttributeCheckbox from "@/components/pages/Attributes/_partials/attributeCheckbox";
import TemplateComponent from "@/components/pages/Attributes/_partials/templateComponent";
export default {
    name: 'model-attributes',
    components: { AttributeCheckbox, TemplateComponent },
    data() {
        return {
            include_archived: false,
            system_selected: [],
            unassigned: false,
            attributeService: AttributeService,
            allAttributes: [],
            isEditing: null,
            isLoading: false,
            modelAttributes: [],
            createAttribute: false,
            form: {
                code: '',
                name: '',
                value: '',
                firm: null,
                attachFirm: true,
            },
            selectedAttribute: null,
            attachId: null,
            openModalAttach: false,
            openCodesModal: false,
        }
    },
    props:{
        model: {
            type: Object,
            required: true,
        },
        type:{
            type: String,
            required: true,
        }
    },
    computed: {
        codeChains() {
            return this.allAttributes.filter(element => element.code == '[SYSTEM][ORDER][CODE_CHAIN]');
        },
        systemAttributes() {
            let data = this.allAttributes.filter(element => {
                if (this.unassigned) {
                    return element.code.toLowerCase().includes('[system]')
                } else {
                    return element.code.toLowerCase().includes('[system]') && element.value != null
                }
            });
            if (this.include_archived) {
                return data;
            } else {
                let ids = this.modelAttributes.filter(element => element.archived_at == null).map(element => element.id)
                return data.filter(element => {
                    return ids.includes(element.id);
                })
            }
        },
        unassignedLength() {
            return this.allAttributes.filter(element => {
                return element.code.toLowerCase().includes('[system]') && element.value == null
            }).length;
        },
        basicAttributes() {
            let data = this.allAttributes.filter(element => !element.code.toLowerCase().includes('[system]'));
            if (this.include_archived) {
                return data;
            } else {
                let ids = this.modelAttributes.filter(element => element.archived_at == null).map(element => element.id)
                return data.filter(element => {
                    return ids.includes(element.id);
                })
            }
        }
    },
    watch: {
        model: {
            handler(model) {
                this.fetchAllAttributes();
            },
            deep: true
        },

        include_archived() {
            this.fetchAllAttributes();
        }

    },
    created(){
        this.fetchAllAttributes();
        this.form.firm = this.model.id;
    },

    methods: {
        achiveRestore(type) {
            let data = {
                custom: true,
                model: 'model_has_attributes',
                type: type,
                column: 'attribute_id',
                ids: this.system_selected,
                model_type: 'Stormport\\Firms\\Firm',
                model_id: this.model.id
            };
            BaseService.achiveRestore(data).then(response => {
                this.$buefy.toast.open({
                    message: "Success!",
                    type: "is-success",
                    position: "is-top-right"
                });
                this.fetchAllAttributes();
            });
        },
        findField(code) {
            let data = {
                field: 'text',
                source: null
            };
            switch(code) {
                case '[SYSTEM][ORDER][PDF_TEMPLATE]': 
                    data.field = 'dropdown';
                    data.source = 'template';
                    break;
                case '[SYSTEM][ORDER][CODE_CHAIN][START]': 
                    data.field = 'dropdown';
                    data.source = 'code';
                    break;
            }
            return data;
        },
        resetForm() {
            this.form.code = '';
            this.form.name = '';
            this.form.value = '';
        },
        async fetchAllAttributes(){
            this.isLoading = true
            let params = {model_type: this.type, model_id: this.model.id, includes: 'attributes,codes,tags'}
            const response = await this.attributeService.all(params);
            this.allAttributes = JsonDenormalizer.denormalize(response);
            this.fetchModelAttributes();
            this.isLoading = false
        },
        async fetchModelAttributes(){
            this.isLoading = true
            let params = {
                    model_type: this.type, 
                    model_id: this.model.id
                }
            const response = await this.attributeService.modelAttributes(params);
            this.modelAttributes = JsonDenormalizer.denormalize(response);
            this.modelAttributes.forEach(attr => {
                let objIndex = this.allAttributes.findIndex((el => el.id == attr.id));
                this.allAttributes[objIndex].value = attr.value
            });
            this.isLoading = false
        },

        async update(attribute){
            this.isLoading = true
            let index = this.allAttributes.findIndex(item => item.id == attribute.id);
            let data = {
                model_type: this.type, 
                model_id: this.model.id,
                attribute_id: attribute.id,
                value: this.$refs["model_" + attribute.id].model,
                // value: this.$refs["model_" + attribute.id].newValue,
            }
            const response = await this.attributeService.attachModelAttributes(data).catch(() => {
                this.isLoading = false
            });
            this.isLoading = false
        },
        hideSaveButton(){
            setTimeout(() => {
                this.isEditing = null
            }, 1000);
        },
        submitForm() {
            AttributeService.create(this.form).then(response => {
                this.createAttribute = false;
                this.$buefy.toast.open({
                    message: "Success!",
                    type: "is-success",
                    position: "is-top-right"
                });
                this.resetForm();
                this.fetchAllAttributes();
            });
        },
        toggleArchive(row, event) {
            AttributeService.toggleArchive({attribute_id: row.id, firm_id: this.model.id}).then(response => {
                let text = event.target.classList.contains('is-warning') ? 'RESTORE' : 'ARCHIVE'; 
                event.target.innerHTML = text;
                event.target.classList.toggle('is-warning');
                event.target.classList.toggle('is-dark');
            });
        },
        modalAttach(row) {
            this.selectedAttribute = row;
            this.openModalAttach = true;
        },
        codelsModal(row) {
            this.selectedAttribute = row;
            this.openCodesModal = true;
        },
        isArchived(row) {
            return this.modelAttributes.find(element => element.id == row.id && element.archived_at != null);
        },
        submitFormAttach() {
            AttributeService.attachAttribute({attribute_id: this.selectedAttribute.id, attachId: this.attachId, attach: true}).then(response => {
                this.openModalAttach = false;
                this.attachId = null;
                this.$buefy.toast.open({
                    message: "Success!",
                    type: "is-success",
                    position: "is-top-right"
                });
                this.fetchAllAttributes();
            });
        },
        archiveAssociatedAttribute(row) {
            AttributeService.attachAttribute({attribute_id: this.selectedAttribute.id, attachId: row.attribute_id, attach: false}).then(response => {
                this.openModalAttach = false;
                this.attachId = null;
                this.$buefy.toast.open({
                    message: "Success!",
                    type: "is-success",
                    position: "is-top-right"
                });
                this.fetchAllAttributes();
            });
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Attributes/_partials/modelAttributes.vue